<template>
  <div
    class="benefit-wrap"
    :class="{ 'benefit-image': item.display_code === 'benefitImage' }"
  >
    <div class="title" v-if="showTitle">
      {{ item.name }}
    </div>
    <div class="desc" v-if="showTitle">
      {{ item.desc }}
    </div>
    <div
      class="content"
      :style="{ background: `url(${item.display_img_url})` }"
    >
      <div class="content-btn" @click="handleShowDetail">查看详情</div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import { useRouter } from "@/components/use/base";

export default defineComponent({
  props: ["item"],
  setup(props) {
    const router = useRouter();

    const showTitle = computed(() => {
      return (
        props.item.display_code !== "benefitImage" &&
        props.item.display_code !== "benefitMoreimage"
      );
    });

    const handleShowDetail = () => {
      const productInfo = props.item.productInfo?.[0] || {};
      const benefitType = productInfo.benefit_type || "";
      if (benefitType)
        router.push(`/benefitDetail?benefit_type=${benefitType}`);
    };

    return {
      showTitle,
      handleShowDetail,
    };
  },
});
</script>

<style lang="less" scoped>
.benefit-wrap {
  padding: 0 12px;
  margin-top: 32px;

  &.benefit-image {
    margin-top: 0;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }

  .content {
    position: relative;
    margin-top: 16px;
    width: 351px;
    height: 122px;
    border-radius: 8px;
    box-sizing: border-box;
    background-repeat: no-repeat !important;
    background-size: 100% !important;

    .content-btn {
      width: 70px;
      height: 24px;
      background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
      border-radius: 13px;
      position: absolute;
      top: 50%;
      right: 23px;
      transform: translateY(-50%);

      font-weight: 500;
      font-size: 12px;
      color: #000000;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
